// interfaces/types
import { FeatureTogglesAndUrlOnly } from './featureToggleTypes';

export const getFeatureToggleState = (state: any): FeatureTogglesAndUrlOnly => {
    return state.featureToggles || ({} as FeatureTogglesAndUrlOnly);
};

const getDealerState = (state: any): any => {
    return state.dealer || {};
};

export const useFnI2 = (state: any): boolean => {
    const dealer = getDealerState(state);
    return dealer.useFnI2 || false;
};

export const creditOverwriteBlockEnabled = (state: any): boolean => {
    return useFnI2(state);
};

export const fakeDealerIcoOff = (state: any): boolean => {
    const featureToggles: FeatureTogglesAndUrlOnly = getFeatureToggleState(state);
    return featureToggles.fakeDealerIcoOff || false;
};


export const enableDebugging = (state: any) => {
    const featureToggles: FeatureTogglesAndUrlOnly = getFeatureToggleState(state);
    return featureToggles.enableDebugging || false;
};


export const isDevHelperEnabled = (state: any) => {
    const featureToggles: FeatureTogglesAndUrlOnly = getFeatureToggleState(state);
    return featureToggles.enableDevHelper || false;
};

export const isMultiTradeInEnabled = (state: any) => {
    const featureToggles: FeatureTogglesAndUrlOnly = getFeatureToggleState(state);
    return featureToggles.enableMultiTradeIns || false;
};


export const isAmdLienPayoffQuoteSpOnSP = (state: any) => {
    const featureToggles: FeatureTogglesAndUrlOnly = getFeatureToggleState(state);
    return featureToggles.amd_lien_payoff_quote_sp || false;
};

const featureToggles = {
    creditOverwriteBlockEnabled,
    fakeDealerIcoOff,
    enableDebugging,
    getFeatureToggleState,
    isDevHelperEnabled,
    isAmdLienPayoffQuoteSpOnSP,
    isMultiTradeInEnabled
};

export default featureToggles;
